import React from 'react'
import WeatherIcon from '../../common/WeatherIcon/WeatherIcon'
import { formatTemperature } from '@/utils/temperature/format'
import { cn } from '@/lib/ui/utils'
import { UUIDFromString } from '@/utils/idGenerator'

export interface LocationPillProps {
  city: string
  degrees: number
  symbol: string
  onClick: () => void
  className?: string
}

const LocationPill: React.FC<LocationPillProps> = ({
  city,
  degrees,
  symbol,
  onClick,
  className,
}) => {
  return (
    <button
      data-cy={`location-pill-${UUIDFromString(city)}`}
      onClick={onClick}
      className={cn(
        'xs:h-auto h-[34px] border-grey-300 hover:bg-grey-100 py-2 px-4 rounded-full border text-xs flex flex-row items-center gap-x-2 bg-white transition-all',
        className,
      )}
    >
      <div
        className="font-semibold whitespace-nowrap text-black max-w-24 truncate"
        data-cy={`location-pill-${UUIDFromString(city)}-city`}
      >
        {city}
      </div>
      <WeatherIcon className="h-[18px] w-auto" name={symbol} />
      <div
        className="font-bold text-black"
        data-cy={`location-pill-${UUIDFromString(city)}-degrees`}
      >
        {formatTemperature(degrees)}°
      </div>
    </button>
  )
}

export default LocationPill
